import { useGlobalState } from 'context/GlobalStateContext'
import { CreateHeaderActionOptions } from '../../../../CIMSTableContext/types/actions/header'
import CreateEditFormItems from '../components/CreateEditFormItems'
import { CreateFormItemsValues } from '../components/CreateEditFormItems/types'
import {
  CreateRPTQuickLinksOptions,
  Entity,
  MutationType,
  RPTQuickLink,
  Refetch,
} from '../types'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'

export function useCreate<Create extends MutationType>({
  mutation,
  permission,
  refetch,
  entity,
  getLabel,
}: Entity &
  Refetch &
  CreateRPTQuickLinksOptions<Create>): CreateHeaderActionOptions<RPTQuickLink> {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const [create] = mutation({
    ...DefaultMutationHookOptions,
    onCompleted: (create) => simpleCreateNotification(getLabel(create).label),
  })
  return {
    permission,
    entity: 'Quick Link',
    modal: {
      type: 'simple',
      body: <CreateEditFormItems entity={entity} />,
      onOk: async (values: CreateFormItemsValues) => {
        if (!projectId) return
        await create({ variables: { input: { projectId, ...values } } })
        refetch()
      },
    },
  }
}
